import { drHelpWhatsappPhoneNumber } from "../../data/Constants";

const navigateToDrHelpWhatsapp = () => {
        window.open(`https://api.whatsapp.com/send?phone=${drHelpWhatsappPhoneNumber}`, "_blank");
}

export default navigateToDrHelpWhatsapp;